import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@fortawesome/fontawesome-free/css/all.min.css';
import 'chartjs-plugin-zoom';

import './mixins/peblConfig.js';
import './plugins/pebl-login-widget.js';
import './plugins/pebl-login-widget.css';

Vue.config.productionTip = false

var PluginPeBL = require('./plugins/PeBLCore.js');
Vue.use(PluginPeBL);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
